import { get, isNil } from '@antv/util';
import { Params } from '../../core/adaptor';
import { deepAssign, flow, renderStatistic } from '../../utils';
import { scale, animation, theme, annotation } from '../../adaptor/common';
import { geometry } from '../progress/adaptor';
import { RingProgressOptions } from './types';

/**
 * coordinate éç½®
 * @param params
 */
function coordinate(params: Params<RingProgressOptions>): Params<RingProgressOptions> {
  const { chart, options } = params;
  const { innerRadius, radius } = options;

  // coordinate
  chart.coordinate('theta', {
    innerRadius,
    radius,
  });

  return params;
}

/**
 * statistic éç½®
 * @param params
 */
export function statistic(params: Params<RingProgressOptions>, updated?: boolean): Params<RingProgressOptions> {
  const { chart, options } = params;
  const { innerRadius, statistic, percent, meta } = options;

  // åæ¸ç©ºæ æ³¨ï¼åéæ°æ¸²æ
  chart.getController('annotation').clear(true);

  /** ä¸­å¿ææ¬ ææ å¡ */
  if (innerRadius && statistic) {
    const metaFormatter = get(meta, ['percent', 'formatter']) || ((v) => `${(v * 100).toFixed(2)}%`);
    let contentOpt = statistic.content;
    if (contentOpt) {
      contentOpt = deepAssign({}, contentOpt, {
        content: !isNil(contentOpt.content) ? contentOpt.content : metaFormatter(percent),
      });
    }
    renderStatistic(
      chart,
      { statistic: { ...statistic, content: contentOpt }, plotType: 'ring-progress' },
      { percent }
    );
  }

  if (updated) {
    chart.render(true);
  }

  return params;
}

/**
 * ç¯å½¢è¿åº¦å¾ééå¨
 * @param chart
 * @param options
 */
export function adaptor(params: Params<RingProgressOptions>) {
  return flow(geometry, scale({}), coordinate, statistic, animation, theme, annotation())(params);
}
